export default "__VITE_ASSET__D$Hd5UBc__";